import { render, staticRenderFns } from "./SocialCalendarDay.vue?vue&type=template&id=21397c8a&scoped=true&"
import script from "./SocialCalendarDay.vue?vue&type=script&lang=js&"
export * from "./SocialCalendarDay.vue?vue&type=script&lang=js&"
import style0 from "./SocialCalendarDay.vue?vue&type=style&index=0&id=21397c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21397c8a",
  null
  
)

export default component.exports